'use strict'
/**
 * Browser Firestore adaptor.
 */
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod
    var result = {}
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k]
    result['default'] = mod
    return result
  }
Object.defineProperty(exports, '__esModule', { value: true })
const firebase = __importStar(require('firebase/app'))
require('firebase/firestore')
const utils_1 = require('./utils')
function store() {
  const firestore = firebase.firestore()
  // At the moment, the browser's Firestore adaptor doesn't support getAll.
  // Get rid of the fallback when the issue is closed:
  // https://github.com/firebase/firebase-js-sdk/issues/1176
  if (!('getAll' in firestore))
    return Object.assign(firestore, { getAll: utils_1.getAll })
  return firestore
}
exports.default = store
function consts() {
  return {
    DocumentReference: firebase.firestore.DocumentReference,
    Timestamp: firebase.firestore.Timestamp,
    FieldValue: firebase.firestore.FieldValue
  }
}
exports.consts = consts
function injectAdaptor() {
  throw new Error(
    'Injecting adaptor is not supported in the browser environment'
  )
}
exports.injectAdaptor = injectAdaptor
//# sourceMappingURL=browser.js.map
